// extracted by mini-css-extract-plugin
module.exports = {"navigationBarWidth":"1340px","moduleAnimationSpeed":"0.3s"};